import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import DateRangeSelect from '@feathr/extender/components/DateRangeSelect';

import type { IDateRangeSection } from './EmailActivityTab/EmailActivityTab.hooks';

export interface ITimeFrameFieldProps {
  state: IDateRangeSection;
}

function TimeFrameField({ state }: Readonly<ITimeFrameFieldProps>): JSX.Element {
  const { t } = useTranslation();
  const {
    selectedDateRange,
    customDateRange,
    dateRangeHadFocus,
    dateRangeOptions,
    dateRangeError,
    handleDateRangeChange,
    handleCustomDateRangeChange,
  } = state;

  return (
    <DateRangeSelect
      customDateRange={customDateRange}
      dateRangeOptions={dateRangeOptions}
      label={t('Time frame')}
      menuPortalTarget={document.body}
      name={'time-frame'}
      onCustomDateRangeChange={handleCustomDateRangeChange}
      onDateRangeChange={handleDateRangeChange}
      selectedDateRange={selectedDateRange}
      validationError={dateRangeHadFocus ? dateRangeError : undefined}
    />
  );
}

export default TimeFrameField;
